import * as Sentry from 'sentry-expo';

export default Sentry.Browser;
